module.exports = __webpack_public_path__ + "static/85fbef45-e6e4-4ff4-8c54-d6da547fb25a-900.5a238896.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/objects/barkVase-kingfisher/85fbef45-e6e4-4ff4-8c54-d6da547fb25a-900.jpg
// module id = 910
// module chunks = 168707334958949